import { render, staticRenderFns } from "./InfiniteCanvas.vue?vue&type=template&id=bece4b0a&scoped=true"
import script from "./InfiniteCanvas.vue?vue&type=script&lang=js"
export * from "./InfiniteCanvas.vue?vue&type=script&lang=js"
import style0 from "./InfiniteCanvas.vue?vue&type=style&index=0&id=bece4b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bece4b0a",
  null
  
)

export default component.exports